import React, { useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import "assets/scss/argon-design-system-react.scss?v1.1.0";

// [_origin]
import Index_origin from "views/Index_origin.js";
import Landing_origin from "views/examples/Landing_origin.js";
import Login_origin from "views/examples/Login_origin.js";
import Profile_origin from "views/examples/Profile_origin.js";
import Register_origin from "views/examples/Register_origin.js";

// [_aecom]
import "assets_/css/wcss.css";
import Navbar from "components_/sub_components/Navbar.js";
import FooterCards from "components_/sub_components/FooterCards.js";
// import Index from "components_/core_tabs/Index";
import AboutCLC from "components_/core_tabs/AboutCLC";
// import Activities from "components_/core_tabs/Activities";
import Events from "components_/core_tabs/Events";
// import FacilitiesBooking from "components_/core_tabs/FacilitiesBooking";
import Venue from "components_/core_tabs/Venue";
// import FacilitiesBookingAdmin from "components_/core_tabs/FacilitiesBookingAdmin";
import VenueBookingAdmin from "components_/core_tabs/VenueBookingAdmin";
import Innovations from "components_/core_tabs/Innovations";
import ContactUs from "components_/core_tabs/ContactUs";

import TestScheduluer from "components_/core_tabs/TestScheduler";

function App() {

  const [languageState, setLanguageState] = useState({ lang: "en" });

  // function updateLanguageState() {
  //   setLanguageState(languageState);
  // }

  const updateLanguageState = param => {
    setLanguageState(param);
  }

  return (

    < BrowserRouter >
      {/* <Navbar languageState={languageState} updateLanguageState={updateLanguageState} /> */}
      <Switch>

        {/* 
        - pass props to child component in React Router: use "render={() => XXX}" instead of "component={}"
        - re-render component every time using inline function: use "render={props => XXX}"
         */}

        {console.log("..[log - app.js, languageState.lang] : ", languageState.lang)}
        // [_aecom - start]
        <Route path="/" exact render={props => <AboutCLC {...props} languageState={languageState} updateLanguageState={updateLanguageState} />} />
        <Route path="/events" exact render={props => <Events languageState={languageState} updateLanguageState={updateLanguageState} />} />
        {/* <Route path="/activities" exact render={props => <Activities {...props} languageState={languageState} updateLanguageState={updateLanguageState} />} /> */}
        {/* <Route path="/facilities_booking" component={FacilitiesBooking} /> */}
        <Route path="/venue" exact render={props => <Venue languageState={languageState} updateLanguageState={updateLanguageState} />} />
        {/* <Route path="/facilities_booking_admin" component={FacilitiesBookingAdmin} /> */}
        <Route path="/venue_booking_admin" exact render={props => <VenueBookingAdmin languageState={languageState} updateLanguageState={updateLanguageState} />} />
        <Route path="/innovations" exact render={props => <Innovations languageState={languageState} updateLanguageState={updateLanguageState} />} />
        <Route path="/contact_us" exact render={props => <ContactUs languageState={languageState} updateLanguageState={updateLanguageState} />} />
        <Route path="/test_scheduler" component={TestScheduluer} />
        // [_aecom - end]

        // [_origin - start]
        <Route path="/index_origin" exact render={props => <Index_origin {...props} />} />
        <Route
          path="/landing_origin"
          exact
          render={props => <Landing_origin {...props} />}
        />
        <Route path="/login_origin" exact render={props => <Login_origin {...props} />} />
        <Route
          path="/profile_origin"
          exact
          render={props => <Profile_origin {...props} />}
        />
        <Route
          path="/register_origin"
          exact
          render={props => <Register_origin {...props} />}
        />
        // [_origin - end]



        <Redirect to="/" />
      </Switch>

      <FooterCards />
    </BrowserRouter >
  );
}

export default App;